// import { apiClient } from './api';


// /**
//  * Create a new BOL
//  */
// export const createBolApi = async (bol: any) => {
//     const result = await apiClient.post<{
//         message: string;
//         data: any;
//     }>('/bol/createBol', { bol });

//     return result;
// };


// /**
//  * Fetch BOL list with pagination + filters
//  */
// export const getBolList = async (payload: {
//     page: number;
//     limit: number;
//     dclocation?: string;
//     filters?: any;
// }) => {
//     const result = await apiClient.post<{
//         data: any[];
//         totalRows: number;
//     }>('/bol/getBolList', {
//         page: payload.page,
//         limit: payload.limit,
//         dclocation: payload.dclocation || '',
//         ...(payload.filters || {}),
//     });

//     return result;
// };


// /**
//  * Update full BOL details.
//  */
// export const updateBol = async (bol: any) => {
//     const result = await apiClient.post<{
//         message: string;
//         data: any[];
//     }>('/bol/updateBol', { bol });

//     return result;
// };


// /**
//  * Update BOL approval status.
//  */
// export const updateBolApproval = async (payload: {
//     status: boolean | null;
//     bol_no: string;
// }) => {
//     const result = await apiClient.post<{
//         message: string;
//         data: any[];
//     }>('/bol/updateApproval', payload);

//     return result;
// };


// /**
//  * Update one BOL status column.
//  */
// export const updateBolStatus = async (payload: {
//     status: boolean | null;
//     bol_no: string;
//     column: string;
// }) => {
//     const result = await apiClient.post<{
//         message: string;
//         data: any[];
//     }>('/bol/updateStatus', payload);

//     return result;
// };


// /**
//  * Fetch accounting BOL list with pagination, search, and filters.
//  */
// export const getAccountingBolList = async (payload: {
//     page: number;
//     limit: number;
//     bol_no?: string;
//     filters?: any;
// }) => {
//     const result = await apiClient.post<{
//         data: any[];
//         totalRows: number;
//     }>('/bol/getAccountingBolList', {
//         page: payload.page,
//         limit: payload.limit,
//         bol_no: payload.bol_no || '',
//         ...(payload.filters || {}),
//     });

//     return result;
// };


// /**
//  * Fetch G2000/vendor BOL list with pagination, search, and filters.
//  */
// export const getBolListG2000 = async (payload: {
//     page: number;
//     limit: number;
//     bol_no?: string;
//     filters?: any;
// }) => {
//     const result = await apiClient.post<{
//         data: any[];
//         totalRows: number;
//     }>('/bol/getBolListG2000', {
//         page: payload.page,
//         limit: payload.limit,
//         bol_no: payload.bol_no || '',
//         ...(payload.filters || {}),
//     });

//     return result;
// };


// /**
//  * Upload files for a BOL (uses FormData, not JSON)
//  */
// export const uploadBolFiles = async (bol_no: string, files: File[]) => {
//     const formData = new FormData();

//     files.forEach((file) => {
//         formData.append('files', file);
//     });

//     formData.append('bol_no', bol_no);

//     const token = localStorage.getItem('persist:root')
//         ? JSON.parse(localStorage.getItem('persist:root') as string)?.user?.sessionId
//         : null;

//     const response = await fetch('/bol/uploadImage', {
//         method: 'POST',
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//     });

//     const data = await response.json();

//     if (!response.ok) {
//         throw new Error(data?.message || 'Error uploading file');
//     }

//     return data;
// };


// /**
//  * Fetch approval BOL list with pagination and filters.
//  */
// export const getApprovalBolList = async (payload: {
//     page: number;
//     limit: number;
//     dclocation?: string;
//     filters?: any;
// }) => {
//     const result = await apiClient.post<{
//         data: any[];
//         totalRows: number;
//     }>('/bol/getApprovalList', {
//         page: payload.page,
//         limit: payload.limit,
//         dclocation: payload.dclocation || '',
//         ...(payload.filters || {}),
//     });

//     return result;
// };
//bolApi.ts
import { apiClient } from './api';


/**
* Create a new BOL
*/
export const createBolApi = async (bol: any) => {
const result = await apiClient.post<{
message: string;
data: any;
}>('/bol/createBol', { bol });

return result;
};


/**
* Fetch BOL list with pagination + filters
*/
export const getBolList = async (payload: {
page: number;
limit: number;
dclocation?: string;
filters?: any;
}) => {
const result = await apiClient.post<{
data: any[];
totalRows: number;
}>('/bol/getBolList', {
page: payload.page,
limit: payload.limit,
dclocation: payload.dclocation || '',
...(payload.filters || {}),
});

return result;
};


/**
* Update full BOL details.
*/
export const updateBol = async (bol: any) => {
const result = await apiClient.post<{
message: string;
data: any[];
}>('/bol/updateBol', { bol });

return result;
};


/**
* Update BOL approval status.
*/
export const updateBolApproval = async (payload: {
status: boolean | null;
bol_no: string;
}) => {
const result = await apiClient.post<{
message: string;
data: any[];
}>('/bol/updateApproval', payload);

return result;
};


/**
* Update one BOL status column.
*/
export const updateBolStatus = async (payload: {
status: boolean | null;
bol_no: string;
column: string;
}) => {
const result = await apiClient.post<{
message: string;
data: any[];
}>('/bol/updateStatus', payload);

return result;
};


/**
* Fetch accounting BOL list with pagination, search, and filters.
*/
export const getAccountingBolList = async (payload: {
page: number;
limit: number;
bol_no?: string;
filters?: any;
}) => {
const result = await apiClient.post<{
data: any[];
totalRows: number;
}>('/bol/getAccountingBolList', {
page: payload.page,
limit: payload.limit,
bol_no: payload.bol_no || '',
...(payload.filters || {}),
});

return result;
};


/**
* Fetch G2000/vendor BOL list with pagination, search, and filters.
*/
export const getBolListG2000 = async (payload: {
page: number;
limit: number;
bol_no?: string;
filters?: any;
}) => {
const result = await apiClient.post<{
data: any[];
totalRows: number;
}>('/bol/getBolListG2000', {
page: payload.page,
limit: payload.limit,
bol_no: payload.bol_no || '',
...(payload.filters || {}),
});

return result;
};


/**
* Upload files for a BOL (uses FormData, not JSON)
*/
export const uploadBolFiles = async (bol_no: string, files: File[]) => {
const formData = new FormData();

files.forEach((file) => {
formData.append('files', file);
});

formData.append('bol_no', bol_no);

const response = await apiClient.form<{
message: string;
data?: any;
}>('/bol/uploadImage', formData);

return response;
};

/**
* Fetch approval BOL list with pagination and filters.
*/
export const getApprovalBolList = async (payload: {
page: number;
limit: number;
dclocation?: string;
filters?: any;
}) => {
const result = await apiClient.post<{
data: any[];
totalRows: number;
}>('/bol/getApprovalList', {
page: payload.page,
limit: payload.limit,
dclocation: payload.dclocation || '',
...(payload.filters || {}),
});

return result;
};